import React, { useState } from 'react';

const INVOICE = { id: 'INV-2025-0892', date: '2025-11-14', due: '2025-12-14', total: '₹1,24,750', items: [{ desc: 'Cloud Hosting (Annual)', amt: '₹84,000' }, { desc: 'Support Package', amt: '₹28,500' }, { desc: 'Setup & Migration', amt: '₹12,250' }] };
const EXPECTED_ANSWER = '₹1,24,750';

export default function C08_AccordionModal({ onComplete }) {
  const [openSection, setOpenSection] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [downloaded, setDownloaded] = useState(false);
  const [answer, setAnswer] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const SECTIONS = [
    { key: 'account', label: 'Account & Profile', content: <p>Manage your account details, profile photo, and display preferences.</p> },
    {
      key: 'billing', label: 'Billing & Payments',
      content: (
        <div>
          <p style={{ marginBottom: 12, fontSize: 13, color: 'var(--text2)' }}>Your billing history and payment methods.</p>
          <table className="ab-table ab-table-sm" style={{ marginBottom: 12 }}>
            <thead><tr><th>Invoice</th><th>Date</th><th>Amount</th><th>Status</th><th></th></tr></thead>
            <tbody>
              <tr>
                <td>{INVOICE.id}</td><td>{INVOICE.date}</td><td>{INVOICE.total}</td>
                <td><span className="ab-badge ab-badge-green">Paid</span></td>
                <td><button className="ab-btn-link" onClick={() => setShowModal(true)}>View Invoice #{INVOICE.id}</button></td>
              </tr>
              <tr>
                <td>INV-2025-0741</td><td>2025-08-10</td><td>₹98,000</td>
                <td><span className="ab-badge ab-badge-green">Paid</span></td>
                <td><button className="ab-btn-link" onClick={() => {}}>View Invoice #INV-2025-0741</button></td>
              </tr>
            </tbody>
          </table>
        </div>
      )
    },
    { key: 'security', label: 'Security & Privacy', content: <p>Two-factor authentication, login sessions, and data privacy settings.</p> },
    { key: 'integrations', label: 'Integrations & API', content: <p>Connected apps, API keys, and webhook configurations.</p> },
  ];

  const normNum = (s) => s.trim().replace(/[₹,\s]/g, '');

  const handleSubmit = () => {
    if (!answer.trim()) return;
    setSubmitted(true);
    const answerCorrect = normNum(answer) === normNum(EXPECTED_ANSWER);
    const pass = answerCorrect && downloaded;
    onComplete({
      score: pass ? 100 : (answerCorrect ? 60 : 0),
      details: {
        totalDue: { expected: EXPECTED_ANSWER, got: answer.trim(), pass: answerCorrect },
        downloadClicked: { expected: 'true', got: String(downloaded), pass: downloaded },
      },
      passed: pass,
    });
  };

  return (
    <div className="ab-challenge-ui">
      <div className="ab-accordion">
        {SECTIONS.map(sec => (
          <div key={sec.key} className={`ab-accordion-item ${openSection === sec.key ? 'ab-accordion-open' : ''}`}>
            <button className="ab-accordion-header" onClick={() => setOpenSection(openSection === sec.key ? null : sec.key)} disabled={submitted}>
              <span>{sec.label}</span>
              <span className="ab-accordion-icon">{openSection === sec.key ? '▲' : '▼'}</span>
            </button>
            {openSection === sec.key && <div className="ab-accordion-body">{sec.content}</div>}
          </div>
        ))}
      </div>

      {showModal && (
        <div className="eval-modal-overlay">
          <div className="eval-modal ab-invoice-modal">
            <div className="ab-modal-header">
              <h3>Invoice {INVOICE.id}</h3>
              <button className="ab-modal-close" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <div className="ab-invoice-meta">
              <span>Invoice Date: <strong>{INVOICE.date}</strong></span>
              <span>Due Date: <strong>{INVOICE.due}</strong></span>
              <span>Status: <strong className="ab-green">Paid</strong></span>
            </div>
            <table className="ab-table ab-table-sm" style={{ margin: '12px 0' }}>
              <thead><tr><th>Description</th><th>Amount</th></tr></thead>
              <tbody>
                {INVOICE.items.map(item => <tr key={item.desc}><td>{item.desc}</td><td>{item.amt}</td></tr>)}
              </tbody>
              <tfoot>
                <tr className="ab-invoice-total">
                  <td><strong>Total Due</strong></td>
                  <td><strong className="ab-total-val">{INVOICE.total}</strong></td>
                </tr>
              </tfoot>
            </table>
            <div className="ab-modal-footer">
              <button className="ab-action-btn" onClick={() => { setDownloaded(true); }}>
                {downloaded ? '✓ PDF Downloaded' : 'Download PDF'}
              </button>
              <button className="eval-btn" onClick={() => setShowModal(false)}>✕ Close</button>
            </div>
          </div>
        </div>
      )}

      <div className="ab-answer-row">
        <label className="ab-label">Total Due from Invoice {INVOICE.id}:</label>
        <input value={answer} onChange={e => setAnswer(e.target.value)} className="ab-input ab-answer-input"
          placeholder="e.g. 1,24,750" disabled={submitted} />
        {!submitted
          ? <button className="ab-action-btn" onClick={handleSubmit}>Submit Answer</button>
          : <div className="ab-submitted-badge">✓ Answer Submitted</div>
        }
      </div>
    </div>
  );
}
